'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;
  var _state$players$player = state.players[playerId],
      durationMs = _state$players$player.durationMs,
      expectedDurationMs = _state$players$player.expectedDurationMs,
      playables = _state$players$player.playables,
      playingIndex = _state$players$player.playingIndex;


  var currentTimeMs = ownProps.playingIndex === playingIndex ? ownProps.currentTimeMs : 0;
  return {
    currentTimeMs: currentTimeMs,
    durationMs: durationMs || 0,
    expectedDurationMs: expectedDurationMs || 0,
    setSeeking: ownProps.setSeeking,
    emitSoftTimeUpdate: ownProps.emitSoftTimeUpdate,
    emitGhostTimeUpdate: ownProps.emitGhostTimeUpdate,
    getMarkItems: ownProps.getMarkItems,
    playables: playables,
    playingIndex: playingIndex
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref2) {
  var playerId = _ref2.playerId;

  return {
    play: function play() {
      dispatch((0, _players.play)(playerId));
    },
    pause: function pause() {
      dispatch((0, _players.pause)(playerId));
    },
    setCurrentTimeMs: function setCurrentTimeMs(currentTimeMs) {
      dispatch((0, _players.setCurrentTimeMs)(playerId, currentTimeMs));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];